import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { H5, H6 } from "../../../AbstractElements";
import { ClockHour5, SVG20, SVG50, SVG68, SVG98, BoxSvg, PendingSvg, ShipSvg } from "../../../Data/Widgets/General/Data";
import CountUp from 'react-countup';
import HeaderCard from "../../Common/Component/HeaderCard";
import { DeliveryTxt, Shipped, pending, processed } from "../../../Constant";
import { Link } from "react-router-dom";
import { getClientUrlDataToken } from "../../../Utils/restUtils";
import { useSelector } from "react-redux";
import { getDashboardOrder, getDashboardOrderRole } from "../../../CommonUrl";

const OrderDetails = () => {
    const authState = useSelector((state) => state.auth);
    const [orderList, setOrderList] = useState([]);
    const [timeFilter, setTimeFilter] = useState('today'); // 'today' as default

    useEffect(() => {
        orderData();
    }, [timeFilter]);

    const OrderDetailsData = [
        {
            id: 1,
            iconClass: 'bg-light-danger',
            svg1: <ClockHour5 />,
            // title: <Link className="dashboardTableLinks" to={`${process.env.PUBLIC_URL}/billing/subscription?expiry=expired`}>
            //     {'Expired'}
            // </Link>,
            title: pending,
            count: orderList.find((o) => o?.status === 'pending')?.count || 0,
            fontClass: 'font-primary',
            // icon: 'icofont-arrow-up',
            // percent: '68%',
            svg2: <SVG68 />
        },
        {
            id: 2,
            iconClass: 'bg-light-warning',
            svg1: <PendingSvg />,
            // title: <Link className="dashboardTableLinks" to={`${process.env.PUBLIC_URL}/billing/subscription?expiry=expire_today`}>
            //     {'Expire Today'}
            // </Link>,
            title: processed,
            fontClass: 'font-warning',
            count: orderList.find((o) => o?.status === 'processing')?.count || 0,
            // icon: 'icofont-arrow-down',
            // percent: '12%',
            svg2: <SVG98 />
        },
        {
            id: 3,
            iconClass: 'bg-light-success',
            svg1: <ShipSvg />,
            // title: <Link className="dashboardTableLinks" to={`${process.env.PUBLIC_URL}/billing/subscription?expiry=expire_tomorrow`}>
            //     {'Expire Tomorrow'}
            // </Link>,
            title: Shipped,
            fontClass: 'font-success',
            count: orderList.find((o) => o?.status === 'shipped')?.count || 0,
            // icon: 'icofont-arrow-up',
            // percent: '50%',
            svg2: <SVG50 />
        },
        {
            id: 4,
            iconClass: 'bg-light-primary',
            svg1: <BoxSvg />,
            // title: <Link className="dashboardTableLinks" to={`${process.env.PUBLIC_URL}/billing/subscription?expiry=expire_5_days`}>
            //     {'Expire Within 5 Days'}
            // </Link>,
            title: DeliveryTxt,
            fontClass: 'font-danger',
            count: orderList.find((o) => o?.status === "delivered")?.count || 0,
            // icon: 'icofont-arrow-up',
            // percent: '20%',
            svg2: <SVG20 />
        },
    ];

    const orderData = async () => {
        const orderDashboard = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getDashboardOrder + `?time=${timeFilter}` : getDashboardOrderRole + `?time=${timeFilter}`);
        if (orderDashboard.status == true) {
            setOrderList(orderDashboard.data);
        } else {
            // setspinnerTrans(false);
        }
    };

    return (
        <Fragment>
            <Col xl="6" className="box-col-6">
                <Card className="widget-joins">
                    <HeaderCard
                        title={
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <span className="header-card-title">Orders</span>
                                <div className="btn-group ms-3">
                                    <button
                                        className={`btn btn-sm ${timeFilter === 'today' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => setTimeFilter('today')}
                                    >
                                        Today
                                    </button>
                                    <button
                                        className={`btn btn-sm ${timeFilter === 'this_month' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => setTimeFilter('this_month')}
                                    >
                                        This Month
                                    </button>
                                </div>
                            </div>
                        }
                        setting={true}
                    />
                    <CardBody>
                        <Row className="gy-4">
                            {OrderDetailsData.map((data) => {
                                return (
                                    <Col sm="6" key={data.id}>
                                        <div className="widget-card">
                                            <div className="d-flex align-self-center">
                                                <div className={`widget-icon ${data.iconClass}`}>
                                                    {data.svg1}
                                                </div>
                                                <div className="flex-grow-1">
                                                    <H6>{data.title}</H6>
                                                    <H5> {data.title === 'Delivered Order' && '$'}
                                                        <span className="counter"><CountUp end={data.count} duration={5} className="m-0" /></span>
                                                        <span className={`font-roboto ${data.fontClass} f-w-700`}>
                                                            <i className={`icofont ${data.icon}`}></i> {data.percent}</span></H5>
                                                    <div className="icon-bg">
                                                        {data.svg2}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                )
                            })}
                        </Row>
                    </CardBody>
                </Card>
            </Col>

        </Fragment>
    );
};

export default OrderDetails;